<mat-toolbar class="content-header">
    <h1 class="page-title">
        <mat-icon>vpn_key</mat-icon>
        {{'settings.project.privacy' | translate}}
        <app-help [link]="helpLink" class="helper-margin"></app-help>
    </h1>

    <span class="toolbar-spacer"></span>
</mat-toolbar>

<div class="privacy-content">
    <div class="">
        <h3>
            {{ "settings.project.keyGen" | translate }}
        </h3>

        <p>
            {{ "settings.project.keyGenDesc" | translate }}
        </p>

        <p>
            {{ "settings.project._keyGenDesc" | translate }}
        </p>

        <div class="key-form">
            <h3>
                {{ "settings.project.api_key" | translate }}
            </h3>

            <div class="info">
                <mat-icon class="icon">key</mat-icon>
                {{ project.accessKey }}

                <lib-button color="none" icon="content_copy" (click)="copy(project.accessKey)">
                </lib-button>
            </div>

            <div class="row">
                <lib-button color="secondary" icon="shuffle" text="{{'settings.project.genKey' | translate}}"
                    (click)="genKey('api')">
                </lib-button>

                <lib-button color="primary" icon="save" text="{{'form.save' | translate}}" (click)="saveKey('api')">
                </lib-button>
            </div>
        </div>

        <div class="key-form">
            <h3>
                {{ "settings.project.rApi_key" | translate }}
            </h3>

            <div class="info">
                <mat-icon class="icon">key</mat-icon>
                {{ project.flowAccessKey }}

                <lib-button [color]="'none'" [icon]="'content_copy'" (click)="copy(project.flowAccessKey)">
                </lib-button>
            </div>

            <div class="row">
                <lib-button color="secondary" icon="shuffle" text="{{'settings.project.genKey' | translate}}"
                    (click)="genKey('flow')">
                </lib-button>

                <lib-button color="primary" icon="save" text="{{'form.save' | translate}}" (click)="saveKey('flow')">
                </lib-button>
            </div>
        </div>
    </div>
</div>